import { mapGetters, mapMutations, mapActions } from 'vuex';
import search from '../../common/search.vue';
import resouceTab from '../../common/resourceTab.vue';
import resourceFilters from '../../common/resourceFilters.vue';
import loading from '../../common/loading.vue';
import empty from '../../common/empty.vue';
import resourceFeedback from '../../common/resourceFeedback.vue';
import templatePayTypeSubscript from "../../common/templatePayTypeSubscript";
import materialPayTypeSubscript from "../../common/materialPayTypeSubscript";
import Analysis from "../analysis/materialBu";

export default {
  name: 'getResources',
  data () {
    return {
      scrollTop: 0, // 页面滚动高度
      params: {
        pIndex: 1,  // 页码从1开始
        sOfPage: 24, // 一般页面成员数量
        fPage: 24, // 首页成员数量
        // style: 78, // 风格
        direction: 1, // 1横2竖，all：全部
        orderBy: 11, // 排序方式（0：时间，11：管理后台最优排序）
        payType: 0, // 支付类型，（空：全部模板，0：免费，1、2、3：付费，4：企业专属）
        isCommerical: '', // 不传：全部，1：可商用；0：不可商用
        keyword: '', // 查询关键字
        category: '', // 分类
      },
      requestLoading: false,
      searchVal: '',
      liHeight: {
        Horizontal: 156,
        Vertical: 234
      },
      currentTab: 'all',
      filterProps: {
        theFormat: 'Horizontal', // Vertical（竖版）
        theMember: {
          name: '付费权限',
          level: ''
        },
        theCategory: {
          name: '全部分类',
          id: ''
        },
        allCategories: {},
      },
      searchValTemp: '',
      lists: [],
      isFocused: false,
    }
  },
  computed: {
    ...mapGetters([
      "TOOL",
      "StyleDataMsg",
      "UserMsg"
    ]),
    ...mapGetters({
      isSearchAll: 'resources/isSearchAll',
      getChoosedResourceType: 'materialArea/getChoosedResourceType',
      globalKeyword: 'resources/globalKeyword'
    }),
    searchingProps () {
      return {
        status: this.isFocused,
        type: this.moduleName === 'template'? '模板': '场景',
        keyVal: this.searchValTemp,
      }
    }
  },
  mixins: [Analysis],
  components: {
    search,
    resouceTab,
    resourceFilters,
    loading,
    templatePayTypeSubscript,
    materialPayTypeSubscript,
    empty,
    resourceFeedback
  },
  watch: {
    "TOOL.optimized" (val) {
      this.filterProps.theFormat = val;
      this.getLists({ type: 'reload' });
    },
    isSearchAll (val) {
      if (val) {
        this.searchAction(this.searchVal);
      } else {
        this.isFocused = false;
        this.searchVal = '';
        this.getLists({ type: 'reload' });
      }
    },
    StyleDataMsg (val) {
      this.getCate();
      this.getLists({ type: 'reload' });
    },
    getChoosedResourceType (nv) {
      if (nv.key === this.moduleName) {
        this.isFocused = false;
        this.searchVal = '';
        if (!this.isSearchAll) {
          this.getLists({type: 'reload'});
        }
      }
    }
  },
  created () {
    this.filterProps.theFormat = this.TOOL.optimized; // 确定用户画布比例
    this.getCate();
    this.isSearchAll || this.getLists({ type: 'reload' });
    this.$bus.on('resources.searchAll', this.searchAction);
  },
  beforeDestroy () {
    this.$bus.off('resources.searchAll', this.searchAction);
  },
  activated () {
    if (this.isSearchAll) {
      this.currentTab = 'all';
      this.getLists({ type: 'reload' });
    }
    if (this.getChoosedResourceType.queue) {
      this.$emit('component-activited', this.getChoosedResourceType.index);
    }
  },
  methods: {
    ...mapActions({
      search: "resources/search",
      getCategory: "resources/category",
      likes: 'resources/likes',
      searchAll: 'resources/searchAll',
      getRecent: 'resources/getRecent',
      setRecent: 'resources/setRecent'
    }),
    leaveItem (index) {
      this.$refs["myvideo" + index][0].pause();
      this.$refs["myvideo" + index][0].currentTime = 0;
      this.$refs["myvideo" + index][0].style.opacity = 0;
    },
    enterItem (item, index) {
      let url = this.$handleAssetsUrl(item.videoUrl).replace(
        ".mp4",
        "nail.mp4"
      );
      if (this.$refs["myvideo" + index][0].src !== url) this.$refs["myvideo" + index][0].src = url;
      this.$refs["myvideo" + index][0].style.opacity = 1;
      this.$refs["myvideo" + index][0].play().then(() => { }).catch(() => { });
    },
    onFocusAction (data) {
      this.isFocused = data;
    },
    collectAction (item) {
      if (this.moduleName === 'template') {
        this.likesAction({ item, flag: item.f });
      } else {
        this.doCollectScene(item);
      }
    },
    async doCollectScene (item) {
      if (this.currentTab === 'collect') {
        if (this.UserMsg.id === item.userId) {
          this.cancelCollectScene(item);
        } else {
          this.likesAction({item, flag: true});
        }
      } else {
        this.likesAction({item, flag: item.favorites});
      }
    },
    cancelCollectScene (item) {
      this.likes({
        type: 'draftScene',
        flag: false,
        id: item.id,
      }).then(()=>{
        this.$message('收藏已取消');
        this.getLists({type: 'reload'});
      }).catch(()=>{
        this.$message('取消收藏失败');
      })
    },
    likesAction ({ item, flag }) {
      this.likes({
        id: item.id,
        type: this.moduleName,
        flag: !flag,
      }).then(() => {
        if (this.moduleName === 'template') {
          item.f = !item.f;
          this.judgeTips(item.f);
        } else {
          item.favorites = !item.favorites;
          this.judgeTips(item.favorites);
        }
      });
    },
    judgeTips(flag) {
      if (flag) {
        this.$message({
          message: "收藏成功",
          type: "success",
        });
        return;
      }
      if (this.currentTab === 'collect') {
        this.getLists({type: 'reload'});
      }
      this.$message("收藏已取消");

    },
    async getCate () {
      let directionProps = this.filterProps.theFormat === 'Horizontal' ? 1 : 2;
      let res = await this.getCategory({ params: { type: this.moduleName, direction: directionProps} });
      res.data = res.data || {};
      this.filterProps.allCategories = Object.keys(res.data).map((item) => {
        return res.data[item];
      }).sort((a, b) => a.power - b.power);
      this.filterProps.allCategories.unshift({ name: '全部分类', id: '' });
    },
    async getLists ({ type, area, global }) {
      let cName = this.$options.name;
      cName = cName[0].toLowerCase() + cName.slice(1)
      if (cName !== this.getChoosedResourceType.content) {
        return;
      }
      if (this.currentTab === 'recent' && type !== 'search' && !this.isSearchAll) {
        this.getRecentData();
        return;
      }
      let requestProps = {};
      this.requestLoading = true;
      if (type === 'reload' || type === 'search') {
        if (type === 'reload') {
          this.searchValTemp = '';
        }
        this.params.pIndex = 1;
        this.lists = [];
        this.$refs[this.moduleName] && this.$refs[this.moduleName].scrollTo(0, 0);
      }

      requestProps.params = {
        ...this.params,
        direction: this.filterProps.theFormat === 'Horizontal' ? 1 : 2,
        payType: this.filterProps.theMember.level,
        category: this.filterProps.theCategory.id,
        keyword: this.searchVal,
        type: this.moduleName
      };
      let flag1 = area && area.type === 'collect';
      let flag2 = type === 'reload' || type === 'next-page';
      let flag3 = this.currentTab === 'collect';
      if (flag1 || (flag2 && flag3)) {
        requestProps.options = {
          type: 'likes'
        }
        requestProps.params.category = '';
        requestProps.params.payType = '';
      }
      // 分类搜索只带页码，每页容量关键词、类型、模板和场景还需带上横竖版参数
      if (type === 'search') {
        requestProps.params = {
          pIndex: this.params.pIndex,
          sOfPage: this.params.sOfPage,
          fPage: this.params.fPage,
          type: this.moduleName,
          keyword: this.searchVal,
          direction: this.filterProps.theFormat === 'Horizontal' ? 1 : 2,
        }
      }

      if (this.isSearchAll && global !== false) {
        this.currentTab = 'all';
        requestProps.params = {
          pIndex: this.params.pIndex,
          sOfPage: this.params.sOfPage,
          fPage: this.params.fPage,
          keyword: this.globalKeyword,
          type: this.moduleName,
          direction: this.moduleName === 'template' ? 'all' : void 0
        }
        if (type === 'reload' || type === 'search') {
          this.$bus.emit('globalSearch.getTotalDict', {keyword: this.globalKeyword});
        }
      }

      this.search(requestProps).then((res) => {
        let data = (res || {}).data || [];
        for (let i = 0; i < data.length; i++) {
          data[i].hoverCommercial = false;
          if (data[i].templateTag && data[i].templateTag.tag) {
            let tagArr = data[i].templateTag.tag.name.split(',');
            data[i].templateTag.tag.splitedTag = tagArr;
          }
        }
        this.requestLoading = false;
        this.lists = this.lists.concat(data);
      });
    },
    ulScroll (event) {
      let ddom = event ? event.target : this.$refs[this.moduleName];
      const scrollHeight = ddom.scrollHeight;
      const height = ddom.offsetHeight;
      const scrollTop = ddom.scrollTop;
      this.scrollTop = scrollTop;
      if (this.requestLoading) {
        return;
      }
      if (scrollTop > (scrollHeight - height - 100) * 0.8) {
        if (this.requestLoading || this.currentTab === 'recent') {
          return;
        }
        this.params.pIndex++;
        this.getLists({ type: 'next-page' });
      }
    },
    chooseOneFilter ({ data, prop }) {
      this.filterProps[prop] = data;
      this.getLists({ type: 'reload' });
    },
    searchAction (val, typeData) {
      this.$emit('search', this.searchVal);
      this.searchValTemp = val;
      if (this.searchVal) {
        this.getLists({ type: 'search' , area: typeData });
      } else {
        this.getLists({ type: 'reload' });
        this.$store.commit('resources/setTotalDict', {});
      }
    },
    chooseTab (data) {
      this.currentTab = data;
      if (this.currentTab === 'recent') {
        this.getRecentData();
        return;
      }
      this.getLists({ type: 'reload' });
    },
    async getRecentData () {
      let props = {
        type: this.moduleName
      };
      this.params.pIndex = 1;
      this.lists = [];
      this.$refs[this.moduleName] && this.$refs[this.moduleName].scrollTo(0, 0);
      this.requestLoading = true;
      props.direction = this.filterProps.theFormat === 'Horizontal' ? 1 : 2;
      let res = await this.getRecent(props);
      let data = res && res.data || [];
      for (let i = 0; i < data.length; i++) {
        data[i].hoverCommercial = false;
      }
      this.lists = data;
      this.$refs[this.moduleName] && this.$refs[this.moduleName].scrollTo(0, 0);
      this.requestLoading = false;
    }
  }
};




// WEBPACK FOOTER //
// ./src/components/mixins/resourcesArea/sceneTemplateMixins.js